exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".alert-message{margin-top:10px;padding:15px;border:1px solid #ebccd1;border-radius:4px;color:#a94442;background-color:#f2dede}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/Modules/AlertMessage/AlertMessage.less
// module id = 1593
// module chunks = 0